function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 14757",
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.431,
    height: 6.437,
    viewBox: "0 0 6.431 6.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21037",
    d: "M5.906 4.657H4.662a2.62 2.62 0 0 1 4.816 1.429h.476A3.1 3.1 0 0 0 4.476 4.1v-.873H4v1.906h1.906z",
    transform: "translate(-3.643 -2.867)",
    style: {
      fill: "#034ea2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21037 - Outline",
    d: "M10.092 6.223h-.714V6.1a2.5 2.5 0 0 0-4.466-1.543h1.131v.714H3.9V3.127h.714v.69A3.215 3.215 0 0 1 10.092 6.1zm-.479-.238h.239A2.978 2.978 0 0 0 4.587 4.2l-.21.253V3.365h-.239v1.668h1.668v-.239H4.462l.119-.184a2.739 2.739 0 0 1 5.032 1.376z",
    transform: "translate(-3.662 -2.886)",
    style: {
      fill: "#034ea2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21038",
    d: "M7.049 17.429h1.244A2.62 2.62 0 0 1 3.476 16H3a3.1 3.1 0 0 0 5.478 1.982v.877h.476v-1.906H7.049z",
    transform: "translate(-2.881 -12.781)",
    style: {
      fill: "#034ea2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21038 - Outline",
    d: "M2.9 15.9h.714v.119a2.5 2.5 0 0 0 4.466 1.548H6.949v-.714h2.143V19h-.714v-.69A3.215 3.215 0 0 1 2.9 16.019zm.479.238H3.14a2.978 2.978 0 0 0 5.266 1.787l.21-.253v1.087h.239V17.09H7.187v.239H8.53l-.119.184a2.739 2.739 0 0 1-5.032-1.375z",
    transform: "translate(-2.9 -12.8)",
    style: {
      fill: "#034ea2"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveRotate);
export default __webpack_public_path__ + "static/media/save-rotate.ede4306f473fb2e9b3b62252a5268ebc.svg";
export { ForwardRef as ReactComponent };